import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel, Select, HStack, Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAcademicYear } from '../../../features/academicYearSlice';
import { getGradosBySede } from '../../../features/gradoSlice';
import { useLocation } from 'react-router-dom';
import ConsolidadoPorPeriodoReporteButton from './ConsolidadoPorPeriodoReporte';

const ConsolidadoPorPeriodo = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const sedeId = location.state?.sedeId;

    const { grados } = useSelector(state => state.grados);
    const { academic_year } = useSelector(state => state.academic_year);

    const initialData = {
        year: '',
        periodo: '',
        grado: '',
        sede: sedeId
    }
    const [data, setData] = useState(initialData);

    useEffect(() => {
        dispatch(getAllAcademicYear());
        dispatch(getGradosBySede(sedeId));
    }, [dispatch, sedeId]);

    return (
        <Box p={4} align="center">
            <HStack spacing={2} justifyContent="stretch">
                <FormControl>
                    <FormLabel>AÑO LECTIVO</FormLabel>
                    <Select
                        placeholder="Seleccione el año lectivo"
                        onChange={e => setData({ ...data, year: e.target.value, periodo: '' })}
                    >
                        {
                            academic_year.map(item => (
                                <option key={item._id} value={item._id}>{item.year}</option>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl>
                    <FormLabel>PERIODO</FormLabel>
                    <Select
                        placeholder="Seleccione el periodo (1 - 4)"
                        value={data.periodo}
                        onChange={e => setData({ ...data, periodo: e.target.value })}
                        isDisabled={!data.year}
                    >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </Select>
                </FormControl>

                <FormControl>
                    <FormLabel>GRADO</FormLabel>
                    <Select
                        placeholder="Seleccione el grado"
                        onChange={e => setData({ ...data, grado: e.target.value })}
                    >
                        {
                            grados.map(grado => (
                                <option key={grado._id} value={grado._id}>{grado?.nombre + ' - ' + grado?.nivel}</option>
                            ))
                        }
                    </Select>
                </FormControl>
            </HStack>
            {
                data.year && data.periodo && data.grado && (
                    <ConsolidadoPorPeriodoReporteButton
                        datos={data}
                        dato_grado={grados.find(grado => grado._id === data.grado)}
                        dato_periodo={academic_year.find(ay => ay._id === data.year)}
                    />
                )
            }

        </Box>
    );
};

export default ConsolidadoPorPeriodo;